export class InterfaceElementCosyDataTypes {
  public static readonly InputTextCosyDataTypeID = '8e83be77-6176-43d9-b39a-dc8d9894cb15';
}
